import { render } from "./CustomSelect.vue?vue&type=template&id=665f49a4&scoped=true&ts=true"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"

import "./CustomSelect.vue?vue&type=style&index=0&id=665f49a4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665f49a4"]])

export default __exports__